import React from "react";
import "styles/NotFound.scss";
import IconEmptyState from "assets/Icons-EmptyState.svg";
export default function NotFound({ heading, buttonText, callback }) {
  return (
    <div className="not-found">
      <div className="not-found-img-container">
        <img
          className="not-found-img"
          src={IconEmptyState}
          alt="not found"
          width="30px"
          height="auto"
        />
      </div>
      <div className="not-found-message-container">
        <h1 className="title">{heading}</h1>
        <p className="not-found-message">
          select from{" "}
          <span onClick={callback} className="not-found-link">
            {buttonText}
          </span>{" "}
          instead
        </p>
      </div>
    </div>
  );
}
